import { Observable } from "./events/Observable";

class Memstore {
    constructor() {
        if (!!Memstore.instance) {
            return Memstore.instance;
        }

        Memstore.instance = this;
        this.seq = 0;
        this.store = new Map(); // Store objects by data.id
        return this;
    }

    save(name, data) {
        if (!data.id || !name) {
            throw new Error("Data must have an 'id' property and entity name");
        }
        const key = `${name}:${data.id}`;
        const wrapper = new SharedObjectWrapper(data, ++this.seq);
        this.store.set(key, wrapper);
        return wrapper;
    }

    get(name, id) {
        const key = `${name}:${id}`;
        return this.store.get(key) || null;
    }
   
}
export const memstore = new Memstore();

class SharedObjectWrapper {

    constructor(data, storeId) {
        this.data = data;
        this.storeId = storeId;
        this.observable = new Observable();
    }

    persist(data) {
        this.data = data;
        this.observable.publish(this.data);
    }

}